import type {ReactElement} from 'react';
import React from 'react';
import {BaseLanguageNotSupportedOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-language-not-supported-option';
import {getRecommendedFont} from '@Libraries/font-library';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';

export function LanguageNotSupportedByTextslideFontOption(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fontFamily = useGetKeyFromTextStylesOfSelectedTextSlideItem('fontFamily');
  const fontScript = useGetKeyFromTextStylesOfSelectedTextSlideItem('script');

  if (!activeItem || !activeSlide) {
    return null;
  }

  if (!activeItem.isSlideshow() || !activeSlide.isTextSlide() || !fontFamily || !fontScript) {
    return null;
  }

  const onClickUseRecommendedFont = (): void => {
    const recommendedFont = getRecommendedFont(activeSlide.textStyles.script);

    void activeItem.updateSlideFromObject(activeSlide.uid, {
      textStyles: {
        fontFamily: recommendedFont,
      },
    });
  };

  return <BaseLanguageNotSupportedOption selectedFontFamily={fontFamily} onClickUseRecommendedFont={onClickUseRecommendedFont} script={fontScript} />;
}
